/**
 * 전자결재 문서번호(docId) 생성.
 * 레거시 PHP: round(array_sum(explode(' ', microtime())) * 10000)
 * 결과: 유닉스 초(10자리) + 마이크로초 앞 4자리 = 14자리 정수 문자열.
 */
export const generateApprovalDocId = (): string => {
  const seconds =
    typeof performance !== 'undefined' &&
    typeof performance.timeOrigin === 'number'
      ? (performance.timeOrigin + performance.now()) / 1000
      : Date.now() / 1000;
  return String(Math.round(seconds * 10000));
};
